define('views/embeds/Podio.Views.Embeds.Embed',['require','underscore','jquery','lib/backbone/Backbone.PodioView','jst!embeds/_embed'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');

  var jstEmbed = require('jst!embeds/_embed');

  return ViewPodioBase.extend({
    className: 'embed-item',

    initialize: function(options) {
      this.embedFile = options.embedFile;

      _.bindAll(this, 'render');
    },

    render: function() {
      var embedView = $(this.getTemplate(jstEmbed, {
        embed: this.model,
        embedFile: this.embedFile,
        showDelete: false,
        onlyHostname: false
      }));
      embedView.appendTo(this.el);
    }
  });

});

